import { LoginDto, LoginResponse } from '@/types/communication/auth';
import { api } from '@/libs/axios';

export const loginUser = async (loginData: LoginDto): Promise<LoginResponse> => {
    return api.post('/login_check', loginData);
};
